import React from "react";

const VARIANT_CLASSNAMES = {
  primary:
    "text-white bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 focus:ring-blue-500 shadow-lg hover:shadow-xl",
  subtle: "text-blue-600 hover:text-blue-700",
};

const SIZE_CLASSNAMES = {
  md: "py-3 px-4 rounded-xl text-sm",
  sm: "py-2 px-3 rounded-lg text-xs",
};

export default function Button({
  type = "button",
  children,
  variant = "primary",
  size = "md",
  className = "",
  disabled = false,
  ...props
}) {
  const variantClasses = VARIANT_CLASSNAMES[variant] || VARIANT_CLASSNAMES.primary;
  const sizeClasses = SIZE_CLASSNAMES[size] || SIZE_CLASSNAMES.md;

  return (
    <button
      type={type}
      disabled={disabled}
      className={`inline-flex justify-center items-center border border-transparent font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 ${sizeClasses} ${variantClasses} ${className}`.trim()}
      {...props}
    >
      {children}
    </button>
  );
}
